import React, { useEffect, useState } from "react";
import i18n from "../../../../../../services/language.service";
import { useTranslation } from "react-i18next";

const TranslateWrapper = () => {
  const [selectedLanguage, setSelectedLanguage] = useState<string | null>("");
  const { t } = useTranslation()

  useEffect(() => {
    setSelectedLanguage(i18n.language);
  }, []);

  useEffect(() => {
    if (selectedLanguage) {
      i18n.changeLanguage(selectedLanguage);
      localStorage.setItem("SELECTED_LNG", selectedLanguage);
    }
  }, [selectedLanguage]);

  return (
    <div className="translate-wrapper">
      <button
        type="button"
        className={`${selectedLanguage === "EN" ? "active" : ""}`}
        onClick={() => setSelectedLanguage("EN")}
        aria-label={String(t("NAVBAR.SELECT_ENGLISH"))}
      >
        EN
      </button>
      <button
        type="button"
        className={`${selectedLanguage === "DE" ? "active" : ""}`}
        onClick={() => setSelectedLanguage("DE")}
        aria-label={String(t("NAVBAR.SELECT_GERMAN"))}
      >
        DE
      </button>
    </div>
  );
};

export default TranslateWrapper;
